<template>
  <div class="paymant-sumary">
    <h2>Pagamento</h2>
     <div v-if="renewalDetails.discountPercentage && renewalDetails.discountAmount">
      <p>Cupom {{ renewalDetails.discountPercentage }}% OFF</p>
      <p><b>- R$ {{ formatDiscount(renewalDetails.discountAmount) }}</b></p>
    </div>
    <div>
      <p>Até 12x sem juros de:</p>
      <p><b>R$ {{ formatValue(renewalDetails.installmentPrice) }}</b></p>
    </div>
    <div class="paymant-sumary__installment">
      <p>Valor Total:</p>
      <p><b>R$ {{ formatValue(renewalDetails.amount) }}</b></p>
    </div>
    <template v-if="!renewalDetails.isAutoRenewal && appSettings.promoCode.enable">
      <div
        v-if="!withPromocode"
        @click="withPromocode = !withPromocode"
        class="paymant-sumary__promocode">
        <span class="paymant-sumary__promocode--add" />
        <p>Adicionar cupom de desconto</p>
      </div>
      <PromoCode
        v-if="withPromocode"
        isRenovation
        :uuid="renewalDetails.cellphoneUuid"
        :promoCode="renewalDetails.promoCode"
        @applied="applied"
        @canceled="canceled"
      />
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PromoCode from '@/components/PromoCode'

export default {
  name: 'RenewalResume',
  components: { PromoCode },
  props: {
    renewalDetails: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      withPromocode: false,
      hasPromoCode: false,
      promoCode: ''
    }
  },
  mounted () {
    const { promoCode } = this.$route.query || this.params

    if (promoCode) {
      this.withPromocode = true
    }
  },
  computed: {
    ...mapState(['appSettings'])
  },
  methods: {
    applied (promo) {
      this.promoCode = promo.promoCode.toUpperCase()
      this.hasPromoCode = true
      this.$emit('applied', promo)
    },
    canceled () {
      this.promoCode = ''
      this.hasPromoCode = false
      this.$emit('canceled')
    },
    formatDiscount (discount) {
      if (!discount) return

      return discount.toFixed(2).replace('.', ',')
    },
    formatValue (value) {
      if (!value) return

      return parseFloat(value).toFixed(2).replace('.', ',')
    }
  }
}
</script>
<style lang="scss" scoped>
.paymant-sumary {
  font-family: Rubik;

  div {
    display: flex;
    justify-content: space-between;
  }

  h2 {
    font: bold 24px Oscine;
    color: #444444;
    margin-bottom: 32px;
  }

  p {
    color: #444444;
    font-size: 14px;
    margin-bottom: 12px;
  }

  &__installment {
    border-top: 1px solid rgba(190, 194, 198, 0.5);
    padding-top: 16px;
    p { font-size: 18px; }
  }

  &__promocode {
    cursor: pointer;
    user-select: none;
    align-items: center;
    justify-content: center !important;
    margin-top: 28px;
    padding-bottom: 32px;
    p {
      margin-left: 8px;
      color: #595959;
    }
    &--add {
      width: 32px;
      height: 32px;
      display: inline-block;
      position: relative;
      background: url(~@/assets/svg/add.svg) no-repeat center;
    }
  }
}
</style>
